import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getBestLanguage } from '../utils/languageStorage';

/**
 * Component that handles automatic language detection and redirection
 * Only used for the root path ("/") to redirect to appropriate language
 * Uses enhanced language storage system with priority handling
 */
function LanguageRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    // Get the best language using our priority system
    const chosenLang = getBestLanguage();
    
    // Redirect to the chosen language with home page
    const { search, hash } = window.location;
    navigate(`/${chosenLang}/${search}${hash}`.replace('//', '/'), { replace: true });
  }, [navigate]);

  // Return null as this component only handles redirection
  return null;
}

export default LanguageRedirect;
